import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

//Critère d'entré du captcha
export type UseRecaptcha = {
    getRecaptchaToken: () => Promise<string>;
};

/**
 * Méthode qui permet de gérer le captcha
 * @param action courrante qui représnte un formulaire normalement
 */
const useRecaptcha = (action: string): UseRecaptcha => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const getRecaptchaToken = useCallback(async () => {
        if (executeRecaptcha) {
            return await executeRecaptcha(action);
        }
        return '';
    }, [action, executeRecaptcha]);

    return { getRecaptchaToken };
};

export default useRecaptcha;
